import { PopupMenuCtrl } from '../controllers/PopupMenuCtrl';
import { Module } from '../Module';

interface TbPopupMenuContentAttributes extends ng.IAttributes {
  matchButtonWidth: string;
  autoExpand?: string;
}

Module.instance().directive('tbPopupMenuContent',
  () => {
    return {
      restrict: 'E',
      transclude: true,
      require: '^tbPopupMenu',
      link: (
        scope: ng.IScope,
        element: JQuery,
        attributes: TbPopupMenuContentAttributes,
        popupMenuCtrl: PopupMenuCtrl,
        transclude: ng.ITranscludeFunction
      ) => {
        popupMenuCtrl.setContent(transclude);
        popupMenuCtrl.contentMatchButtonWidth = (attributes.matchButtonWidth === 'true');
        popupMenuCtrl.autoExpand = (attributes.autoExpand === 'true');
      }
    };
  }
);
